import { DateTime } from 'luxon';
import type { FC } from 'react';
import { useEffect, useState } from 'react';

export const Clock: FC = () => {
  const [when, setWhen] = useState(new Date());

  useEffect(() => {
    const handle = setInterval(() => {
      setWhen(new Date());
    });
    return () => clearInterval(handle);
  }, []);
  return (
    <>{DateTime.fromJSDate(when).toLocaleString(DateTime.TIME_WITH_SECONDS)}</>
  );
};
